<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="9" cy="6" r="1.25" fill="currentColor" />
  <circle cx="15" cy="6" r="1.25" fill="currentColor" />
  <circle cx="9" cy="12" r="1.25" fill="currentColor" />
  <circle cx="15" cy="12" r="1.25" fill="currentColor" />
  <circle cx="9" cy="18" r="1.25" fill="currentColor" />
  <circle cx="15" cy="18" r="1.25" fill="currentColor" />
</svg>
